import React from 'react'
import Header from './components/Layout/Header';
import SidebarLeft from './components/Layout/SidebarLeft';

const Base = props => (
    <div className="" id="main-wrapper">
        <Header />
        
        <SidebarLeft />
        <div>
            {props.children}
        </div>

    </div>
)


export default Base